import clsx from "clsx";
import React, { useMemo } from "react";

import IcnAddCircle from "@assets/icons/rounded/add_circle.svg";
import { ImageComponent } from "@app/core/image/image.component";
import { CurrencyComponent } from "@app/core/currency/currency.component";
import { IconComponent } from "@app/core";
import { DataWarehouseProductDTO } from "@app/bf-api";

import styles from "./deal-card-add-alert.module.scss";
import { useAppSelector } from "@app/redux/store";

export interface IDealCardAddAlertProps {
  deal: DataWarehouseProductDTO;
  onClick?: (deal: DataWarehouseProductDTO) => void;
  className?: string;
}

export const DealCardAddAlert = (props: IDealCardAddAlertProps) => {
  const { ean, image_url, merchant, name, price } = props.deal;
  const { likedEans } = useAppSelector((state) => state.auth);

  const isLiked = useMemo(() => likedEans?.find((likedEan) => likedEan === ean), [likedEans, ean]);

  if (isLiked) {
    return <></>;
  }

  return (
    <button
      type="button"
      data-cy="deal-like"
      data-ean={ean}
      className={clsx(styles.dealCard, props.className)}
      onClick={() => props.onClick?.(props.deal)}
    >
      <div className={styles.imageWrapper}>
        <div className={styles.image}>
          <ImageComponent src={image_url} alt={name} title={name} isBlocking />
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.merchantNameWrapper}>
          {merchant && (
            <span title={merchant} className={styles.merchantName}>
              {merchant}
            </span>
          )}
        </div>

        <div className={styles.titleWrapper}>
          <span className={styles.title}>
            <h4 title={name}>{name}</h4>
          </span>
        </div>
        <div className={styles.price}>
          {!!price && (
            <div className={styles.priceBox}>
              {/* We won't show this now as we dont have an accurate before price */}
              {/* {!!beforePrice && showBeforePrice && (
                <div className={styles.priceOld}>
                  <CurrencyComponent value={beforePrice} variant="old" />
                </div>
              )} */}
              {!!price && (
                <div className={clsx(styles.priceNew)}>
                  <CurrencyComponent value={Number(price)} variant="new" />
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <IconComponent className={styles.icon} icon={IcnAddCircle} size="24px" />
    </button>
  );
};
